module.exports = __webpack_public_path__ + "img/pen.a866794c.svg";